/* Activeat motion helper: scroll-reveal via IntersectionObserver.
   The .aat-motion-ok class gates hidden states so content is never
   invisible without JS or under reduced motion. */
(() => {
  const reduce = window.matchMedia('(prefers-reduced-motion: reduce)');
  if (reduce.matches || !('IntersectionObserver' in window)) return;

  document.documentElement.classList.add('aat-motion-ok');

  const io = new IntersectionObserver(
    (entries) => {
      for (const entry of entries) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-in');
          io.unobserve(entry.target);
        }
      }
    },
    { rootMargin: '0px 0px -8% 0px', threshold: 0.08 }
  );

  const observeAll = (root) => {
    root.querySelectorAll('.aat-reveal:not(.is-in)').forEach((el) => io.observe(el));
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => observeAll(document));
  } else {
    observeAll(document);
  }

  /* Re-observe after theme editor section reloads. */
  document.addEventListener('shopify:section:load', (e) => observeAll(e.target));
})();
